export default "__VITE_ASSET__B$iZJvVQ__"